import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {
    GameTag,ListGameTagResponse,
} from "../http/protocol";


export class CasinoGameTagService  extends AbstractAdminEntityService<GameTag, ListGameTagResponse>  {

    constructor(http : HttpService) {
        super("/casino-game-tag", http)
    }

}